module.exports = __webpack_public_path__ + "img/suit-02.a5022e01.png";